import React from "react";
import StatusBar from "../../preapps/StatusBar";
const SalesPreappStatusBarParent = ({ currentStatus, t }) => {
    const CurrentProgressionIcon = (progressionId) => {
        if (progressionId < 5) {
            return "#b6d7a8";
        }
        if (progressionId > 4 && progressionId < 7) {
            return "#a2c4c9";
        }
        if (progressionId == 7) {
            return "#a4c2f4";
        }
        if (progressionId == 8) {
            return "#b4a7d6";
        }
        if (progressionId == 9) {
            return "#ffe599";
        }
        if (progressionId > 10 && progressionId < 16) {
            return "#ff6d01";
        }
        if (progressionId == 10 || (progressionId > 15 && progressionId < 19)) {
            return "#ffff00";
        }
        if (progressionId > 18 && progressionId < 25) {
            return "#34a853";
        }
        if (progressionId > 24 && progressionId < 26) {
            return "#ea4335";
        }
        return "";
    };
    return (
        <div className="table-div-td col-status col-status-hover">
            <ul>
                <li>
                    <div className="app-circle">
                        <i
                            className="fa fa-circle"
                            aria-hidden="true"
                            style={{
                                color: CurrentProgressionIcon(
                                    t[1].lead_progression_id,
                                ),
                            }}
                            title={currentStatus}
                        />
                    </div>
                </li>
                {t[1].child.map((child, index) => (
                    <li>
                        <div className="app-circle">
                            <i
                                className="fa fa-circle"
                                aria-hidden="true"
                                style={{
                                    color: CurrentProgressionIcon(
                                        child.lead_progression_id,
                                    ),
                                }}
                            />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SalesPreappStatusBarParent;
